const getCrimeNames = (value) => {
  const crimes = Array.isArray(value) ? value : value ? [value] : [];

  return crimes
    .map((crime) =>
      typeof crime === "string" ? crime : crime?.crime || crime?.name || "",
    )
    .filter(Boolean);
};

export const formatAuthorityCrimes = (authority) => {
  if (!authority) return "-";

  const mpCrimes = getCrimeNames(
    authority.mpCrimes ?? authority.mp_crimes ?? authority.mp_crime,
  );
  const parts = [...mpCrimes];

  if (authority.violation) parts.push(authority.violation);

  return parts.join(" / ") || "-";
};
